module.exports = {
    handle: (e, data) => {
        if (data.gtmData) {
            const {
                gtmData: {
                    products,
                    actionField,
                }
            } = data;

            dataLayer.push({ ecommerce: null });

            const { customerId, emailAddress } = actionField;

            const purchaseData = {
                event: 'eec.purchase',
                ecommerce: {
                    purchase: {
                        actionField: {
                            id: actionField.id,
                            affiliation: actionField.affiliation,
                            revenue: actionField.revenue,
                            tax: actionField.tax,
                            shipping: actionField.shipping,
                            coupon: actionField.coupon,
                            subscription: actionField.subscription
                        },
                        products: products,
                    }
                }
            };

            customerId ? purchaseData.userId = customerId : null;
            emailAddress ? purchaseData.email = emailAddress : null;

            dataLayer.push(purchaseData);
        }
    }
}